import { Snackbar, SNACKBAR_TYPES } from "@lysaab/ui-2";
import React from "react";
import { FormattedMessage } from "react-intl";
import { NonClearedBreakdownList } from "./NonClearedBreakdownList";
export const OnfidoConsider = ({ poaStatus }) => {
    if (poaStatus.nonClearedBreakdowns.length) {
        return React.createElement(NonClearedBreakdownList, { poaStatus: poaStatus });
    }
    if (poaStatus.checkType === "POA_ID_CARD") {
        return (React.createElement("div", { className: "snackbar-wrapper" },
            React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR, icon: true },
                React.createElement(FormattedMessage, { id: "onfido.status.poa.onfido_consider.poa_id_card" }))));
    }
    return (React.createElement("div", { className: "snackbar-wrapper" },
        React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR, icon: true },
            React.createElement(FormattedMessage, { id: "onfido.status.poa.onfido_consider.generic" }))));
};
